export const TIMEZONES = [
  { value: '−12:00', label: 'UTC−12:00 Baker Island, Howland Island' },
  { value: '−11:00', label: 'UTC−11:00 Niue, American Samoa' },
  { value: '−10:00', label: 'UTC−10:00 Honolulu' },
  { value: '−09:30', label: 'UTC−09:30 Marquesas Islands' },
  { value: '−09:00', label: 'UTC−09:00 Anchorage' },
  { value: '−08:00', label: 'UTC−08:00 Los Angeles, Vancouver, Tijuana' },
  { value: '−07:00', label: 'UTC−07:00 Denver, Calgary, Ciudad Juárez' },
  {
    value: '−06:00',
    label:
      'UTC−06:00 Mexico City, Chicago, Guatemala City, Tegucigalpa, Winnipeg, San José, San Salvador',
  },
  { value: '−05:00', label: 'UTC−05:00 New York, Toronto, Havana, Lima, Bogotá, Kingston, Quito' },
  { value: '−04:00', label: 'UTC−04:00 Santiago, Santo Domingo, Manaus, Caracas, La Paz, Halifax' },
  { value: '−03:30', label: 'UTC−03:30 Newfoundland and Labrador' },
  { value: '−03:00', label: 'UTC−03:00 São Paulo, Buenos Aires, Montevideo' },
  { value: '−02:00', label: 'UTC−02:00 Fernando de Noronha, Greenland' },
  { value: '−01:00', label: 'UTC−01:00 Cape Verde, Azores Islands' },
  { value: '+00:00', label: 'UTC+00:00 London, Dublin, Lisbon, Abidjan, Accra, Dakar' },
  {
    value: '+01:00',
    label:
      'UTC+01:00 Berlin, Rome, Stockholm, Paris, Madrid, Warsaw, Lagos, Kinshasa, Algiers, Casablanca',
  },
  {
    value: '+02:00',
    label:
      'UTC+02:00 Athens, Bucharest, Cairo, Helsinki, Jerusalem, Johannesburg, Khartoum, Kyiv, Riga, Sofia',
  },
  {
    value: '+03:00',
    label: 'UTC+03:00 Moscow, Istanbul, Riyadh, Baghdad, Addis Ababa, Doha, Nairobi, Kuwait City',
  },
  { value: '+03:30', label: 'UTC+03:30 Tehran' },
  { value: '+04:00', label: 'UTC+04:00 Dubai, Baku, Tbilisi, Yerevan, Samara' },
  { value: '+04:30', label: 'UTC+04:30 Kabul' },
  { value: '+05:00', label: 'UTC+05:00 Karachi, Astana, Tashkent, Yekaterinburg' },
  { value: '+05:30', label: 'UTC+05:30 Delhi, Mumbai, Colombo' },
  { value: '+05:45', label: 'UTC+05:45 Kathmandu' },
  { value: '+06:00', label: 'UTC+06:00 Dhaka, Omsk' },
  { value: '+06:30', label: 'UTC+06:30 Yangon' },
  { value: '+07:00', label: 'UTC+07:00 Jakarta, Ho Chi Minh City, Bangkok, Krasnoyarsk' },
  {
    value: '+08:00',
    label:
      'UTC+08:00 Shanghai, Taipei, Hong Kong, Kuala Lumpur, Singapore, Perth, Manila, Makassar, Irkutsk',
  },
  { value: '+08:45', label: 'UTC+08:45 Western Australia' },
  { value: '+09:00', label: 'UTC+09:00 Tokyo, Seoul, Pyongyang, Jayapura, Chita' },
  { value: '+09:30', label: 'UTC+09:30 Adelaide' },
  { value: '+10:00', label: 'UTC+10:00 Sydney, Melbourne, Brisbane, Port Moresby, Vladivostok' },
  { value: '+10:30', label: 'UTC+10:30 Lord Howe Island' },
  { value: '+11:00', label: 'UTC+11:00 Nouméa' },
  { value: '+12:00', label: 'UTC+12:00 Auckland, Suva, Petropavlovsk-Kamchatsky' },
  { value: '+12:45', label: 'UTC+12:45 Chatham Islands' },
  { value: '+13:00', label: 'UTC+13:00 Phoenix Islands, Tokelau, Samoa, Tonga' },
  { value: '+14:00', label: 'UTC+14:00 Line Islands' },
];

export const UTC_TIMEZONE_VALUE = '+00:00'
